import { FC } from "react";
import { Styles } from "./styled";
import useMaintenanceNotificationList, { Props, ReceivedProps } from "./hook";
import MainContent from "./MainContent";
import { MainStyles } from "./styled";

const MaintenanceNotificationListLayout: FC<Props> = () => {
  return (
    <Styles>
      <MainStyles>
        <MainContent />
      </MainStyles>
    </Styles>
  );
};

const MaintenanceNotificationList: FC<ReceivedProps> = (props) => (
  <MaintenanceNotificationListLayout
    {...useMaintenanceNotificationList(props)}
  />
);

export default MaintenanceNotificationList;
